export default "__VITE_ASSET__QRPyH8Tq__"